// extracted by mini-css-extract-plugin
export default {"root":"IlHNt","desktop":"Fr6rE","rounded":"ATJR5","stat":"z3RAn","tablet":"yPDPV","compact":"HU8uT","mobile":"ENKoi","smallMobile":"pvUwm","icon":"p1uqV","light":"CJ8r_"};